module.exports = __webpack_public_path__ + "static/img/yibiaopan.eee9c4ac.png";